import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classNames from 'classnames';
import Sentence from './sentence';

export default class PrintableTranscript extends Component {
    static propTypes = {
        elementList: ImmutablePropTypes.map.isRequired,
        title: PropTypes.string.isRequired,
        rtl: PropTypes.bool.isRequired,
    };

    getStyles() {
        return `
            html {
                font: 12px/18px Arial, sans-serif;
                padding: 10px;
                color: #626366;
            }
            h1 {
                font-size: 14px;
                padding-bottom: 10px;
                border-bottom: 1px solid #626366;
            }
            .rtl {
                text-align: right;
            }
            .speaker {
                font-weight: bold;
            }
            .timestamp {
                font-size: 10px;
            }
            .sentence + .sentence {
                margin-top: 10px;
            }
            .branding {
                color: #626366;
                margin-top: 10px;
                padding-top: 10px;
                border-top: 1px solid #626366;
            }
        `;
    }

    render() {
        return (
            <html>
                <head>
                    <style>{this.getStyles()}</style>
                </head>
                <body>
                    <h1>{this.props.title}</h1>
                    <div className={classNames({'cielo24-vwrap-rtl': this.props.rtl})}>
                        {this.props.elementList.get('segments').map(segment => (
                            <Sentence
                                key={`segment-${segment.get('startTime')}`}
                                segment={segment}
                                showSpeaker={true}
                                showTimestamp={true}
                            />
                        ))}
                    </div>
                    <div className='cielo24-vwrap-branding'>cielo24 | what’s in your video? | cielo24.com</div>
                </body>
            </html>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/transcript/print.js